const copperHeroData = {
  images: {
    desktop:
      'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,w_1920,f_auto/v1736976853/assets/copper-weekly/Copper_Sheets_tyswa7.png',
    mobile:
      'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,w_1024,f_auto/v1736976853/assets/copper-weekly/Copper_Sheets_tyswa7.png',
  },
  subTitle: 'Benchmark launches new Copper Service',
  listItems: [
    'Copper price forecasts',
    'Copper supply database and end-use demand segmentation',
    'Comprehensive copper market balances',
    'Clear and transparent copper data with customisable assumptions',
  ],
}

export default copperHeroData
